import { getAttributeConfig } from "../config";
import type { AttributeAggregation, RawAttributeAggregations } from "../types";

export const normalizeAttributeAggregations = (aggregations: RawAttributeAggregations): AttributeAggregation[] => {
  if (!aggregations) return [];

  return aggregations.reduce<AttributeAggregation[]>((acc, aggregation) => {
    // Labels are owned by Magento: an aggregation or option without one is a data defect and is dropped
    // rather than rendered as an empty heading or a raw option id.
    if (!aggregation?.label || !getAttributeConfig(aggregation.attribute_code)) {
      return acc;
    }

    const seenValues = new Set<string>();
    const options = (aggregation.options ?? []).flatMap((option) => {
      if (!option?.label || seenValues.has(option.value)) return [];

      seenValues.add(option.value);
      return [{ value: option.value, label: option.label }];
    });

    if (options.length === 0) return acc;

    acc.push({
      attributeCode: aggregation.attribute_code,
      label: aggregation.label,
      options,
    });

    return acc;
  }, []);
};
